import { FunctionComponent, memo } from 'react';
import { CalloutBlockData, useLinkify } from '../../../../shared';

import classes from './Callout.module.scss';

export const Callout: FunctionComponent<CalloutBlockData> = memo(({ text }) => {
  const { linkify } = useLinkify();

  return (
    <div className={classes['callout']}>
      {text && <div dangerouslySetInnerHTML={{ __html: linkify(text) }}></div>}
    </div>
  );
});
